export const DEFAULT_SIDEBAR_WIDTH = 280;
export const DEFAULT_THREAD_WIDTH = 390;
export const MIN_SIDEBAR_WIDTH = 220;
export const MIN_THREAD_WIDTH = 300;
export const MIN_TIMELINE_WIDTH = 360;

export function constrainChatPanelWidth(panel, requestedWidth, pageWidth, layout, hasThread, hasSidebar = true) {
    const otherPanelWidth = panel === 'sidebar'
        ? (hasThread ? layout.thread : 0)
        : (hasSidebar ? layout.sidebar : 0);
    const minimum = panel === 'sidebar' ? MIN_SIDEBAR_WIDTH : MIN_THREAD_WIDTH;
    const maximum = Math.max(minimum, pageWidth - otherPanelWidth - MIN_TIMELINE_WIDTH);
    return Math.round(Math.min(maximum, Math.max(minimum, requestedWidth)));
}

export function storedChatPanelWidth(key, fallback) {
    const value = Number(localStorage.getItem(key));
    return Number.isFinite(value) && value > 0 ? value : fallback;
}
